define('BookingEngine/app-OceanCruises/settings',[],function () {
    return {
        container: '#cruiseFilters, #cruiseCabinGrades, #cruisePickYourCabin',
        deckplans: window.location.protocol + '//' + window.location.host + '/sagaoceancruisemodule/getdeckplan',
        virtualtour: window.location.protocol + '//' + window.location.host + '/sagaoceancruisemodule/getvirtualtour',
        cruiseurl: window.location.protocol + '//' + window.location.host + '/sagaoceancruisemodule/index',
        filterurl: window.location.protocol + '//' + window.location.host + '/sagaoceancruisemodule/selectfilter',
        gradesurl: window.location.protocol + '//' + window.location.host + '/sagaoceancruisecabingrademodule/selectmastergrade',
        guaranteegradesurl: window.location.protocol + '//' + window.location.host + '/sagaoceancruisecabingrademodule/selectguaranteegrade',
        cabinsurl: window.location.protocol + '//' + window.location.host + '/sagaoceancruisepickcabinmodule/selectcabin',
        activate: window.location.protocol + '//' + window.location.host + '/sagaoceancruisemodule/activate'
    };
});
